<template>
  <v-dialog v-model="visible" max-width="100%">
    <v-card class="overflow-y-hidden">
      <v-card-title class="d-flex align-center">
        <span>{{ titulo }}</span>
      </v-card-title>

      <v-divider class="my-0"></v-divider>

      <v-card-text class="pa-4">
        <v-tabs>
          <v-tab> INGRESOS </v-tab>
          <v-tab> GASTOS </v-tab>
          <v-tab> GASTOS POR GRUPO </v-tab>
          <v-tab> GASTOS POR GRUPO POR MESES </v-tab>

          <v-tab-item class="item-tab">
            <v-btn small class="ml-4" @click="descargarPresupuestosIngresosConsolidado">
              <v-icon>mdi-microsoft-excel</v-icon>
              Exportar
            </v-btn>

            <TablaPresupuestos :presupuestos="presupuestosIngresos" />
          </v-tab-item>

          <v-tab-item class="item-tab">
            <v-btn small class="ml-4" @click="descargarPresupuestosGastosConsolidado">
              <v-icon>mdi-microsoft-excel</v-icon>
              Exportar
            </v-btn>

            <TablaPresupuestos :presupuestos="presupuestosGastos" />
          </v-tab-item>

          <v-tab-item class="item-tab">
            <v-btn small class="ml-4" @click="descargarPresupuestosGastosPorGrupo">
              <v-icon>mdi-microsoft-excel</v-icon>
              Exportar
            </v-btn>

            <TablaPresupuestosPorGrupo :presupuestos="presupuestosGastosPorGrupo" />
          </v-tab-item>

          <v-tab-item class="item-tab">
            <v-btn small class="ml-4" @click="descargarPresupuestosGastosPorGrupoPorMeses">
              <v-icon>mdi-microsoft-excel</v-icon>
              Exportar
            </v-btn>

            <TablaPresupuestosPorGrupoPorMeses :presupuestos="presupuestosGastosPorGrupoPorMeses" />
          </v-tab-item>
        </v-tabs>
      </v-card-text>

      <v-divider class="my-0"></v-divider>

      <v-card-actions>
        <v-btn color="blue darken-1" text @click.prevent="cerrar()"> Cerrar </v-btn>
      </v-card-actions>

      <notifications group="notifications" position="top right" />
    </v-card>
  </v-dialog>
</template>

<script>
import TablaPresupuestos from './TablaPresupuestos.vue';
import PresupuestosServices from './../services/index';
import { TIPOS_PRESUPUESTOS } from '../utils';
import TablaPresupuestosPorGrupo from './TablaPresupuestosPorGrupo.vue';
import TablaPresupuestosPorGrupoPorMeses from './TablaPresupuestosPorGrupoPorMeses.vue';
import ReportesExcelService from '../services/reportes-excel';
import DescargarExcelMixin from '../mixins/descargar-excel.mixin';

export default {
  name: 'ModalPresupuestos',
  mixins: [DescargarExcelMixin],
  components: {
    TablaPresupuestos,
    TablaPresupuestosPorGrupo,
    TablaPresupuestosPorGrupoPorMeses,
  },
  data() {
    return {
      visible: false,
      tiposPresupuestos: TIPOS_PRESUPUESTOS,
      presupuesto: null,
      presupuestosIngresos: [],
      presupuestosGastos: [],
      presupuestosIngresosPorGrupo: [],
      presupuestosGastosPorGrupo: [],
      presupuestosIngresosPorGrupoPorMeses: [],
      presupuestosGastosPorGrupoPorMeses: [],
    };
  },
  computed: {
    titulo() {
      return `PRESUPUESTOS GESTIÓN ${this.presupuesto?.gestion?.numero}`;
    },
  },
  methods: {
    abrir(presupuesto) {
      this.presupuesto = presupuesto;
      this.visible = true;
      this.listarPresupuesto(this.tiposPresupuestos.INGRESO);
      this.listarPresupuesto(this.tiposPresupuestos.GASTO);
      this.listarPresupuestoAgrupado(this.tiposPresupuestos.GASTO);
      this.listarPresupuestoAgrupadoPorMeses(this.tiposPresupuestos.GASTO);
    },
    cerrar() {
      this.presupuesto = null;
      this.visible = false;
      this.presupuestosIngresos = [];
      this.presupuestosGastos = [];
      this.presupuestosIngresosPorGrupo = [];
      this.presupuestosGastosPorGrupo = [];
      this.presupuestosIngresosPorGrupoPorMeses = [];
      this.presupuestosGastosPorGrupoPorMeses = [];
    },
    async listarPresupuesto(tipo) {
      this.presupuestosIngresos = [];
      this.presupuestosGastos = [];

      try {
        const { data } = await PresupuestosServices.consolidadoGestion(this.presupuesto.id, tipo);
        const { datos, mensaje } = data;

        if (tipo == this.tiposPresupuestos.INGRESO) {
          this.presupuestosIngresos = datos;
        }

        if (tipo == this.tiposPresupuestos.GASTO) {
          this.presupuestosGastos = datos;
        }

        this.$notify({
          group: 'notifications',
          title: `${this.titulo} - ${tipo.toUpperCase()}`,
          text: mensaje || 'Listado exitoso',
          type: 'success',
        });
      } catch (error) {
        const { mensaje } = error?.response?.data;

        window.console.log(error);

        this.$notify({
          group: 'notifications',
          title: 'Error',
          text: mensaje || 'Error al listar',
          type: 'error',
        });
      }
    },
    async listarPresupuestoAgrupado(tipo) {
      this.presupuestosIngresosPorGrupo = [];
      this.presupuestosGastosPorGrupo = [];

      try {
        const { data } = await PresupuestosServices.agrupadoGestion(this.presupuesto.id, tipo);
        const { datos, mensaje } = data;

        if (tipo == this.tiposPresupuestos.INGRESO) {
          this.presupuestosIngresosPorGrupo = datos;
        }

        if (tipo == this.tiposPresupuestos.GASTO) {
          this.presupuestosGastosPorGrupo = datos;
        }

        this.$notify({
          group: 'notifications',
          title: `${this.titulo} - ${tipo.toUpperCase()}`,
          text: mensaje || 'Listado exitoso',
          type: 'success',
        });
      } catch (error) {
        const { mensaje } = error?.response?.data;

        window.console.log(error);

        this.$notify({
          group: 'notifications',
          title: 'Error',
          text: mensaje || 'Error al listar',
          type: 'error',
        });
      }
    },
    async listarPresupuestoAgrupadoPorMeses(tipo) {
      this.presupuestosIngresosPorGrupoPorMeses = [];
      this.presupuestosGastosPorGrupoPorMeses = [];

      try {
        const { data } = await PresupuestosServices.agrupadoGestionPorMeses(this.presupuesto.id, tipo);
        const { datos, mensaje } = data;

        if (tipo == this.tiposPresupuestos.INGRESO) {
          this.presupuestosIngresosPorGrupoPorMeses = datos;
        }

        if (tipo == this.tiposPresupuestos.GASTO) {
          this.presupuestosGastosPorGrupoPorMeses = datos;
        }

        this.$notify({
          group: 'notifications',
          title: `${this.titulo} - ${tipo.toUpperCase()}`,
          text: mensaje || 'Listado exitoso',
          type: 'success',
        });
      } catch (error) {
        const { mensaje } = error?.response?.data;

        window.console.log(error);

        this.$notify({
          group: 'notifications',
          title: 'Error',
          text: mensaje || 'Error al listar',
          type: 'error',
        });
      }
    },
    descargarPresupuestosIngresosConsolidado() {
      const opciones = {
        params: {
          tipo: this.tiposPresupuestos.INGRESO,
        },
      };

      return this.descargarExcel(ReportesExcelService.consolidado, this.presupuesto.id, opciones);
    },
    descargarPresupuestosGastosConsolidado() {
      const opciones = {
        params: {
          tipo: this.tiposPresupuestos.GASTO,
        },
      };

      return this.descargarExcel(ReportesExcelService.consolidado, this.presupuesto.id, opciones);
    },
    descargarPresupuestosGastosPorGrupo() {
      const opciones = {
        params: {
          tipo: this.tiposPresupuestos.GASTO,
        },
      };

      return this.descargarExcel(ReportesExcelService.agrupado, this.presupuesto.id, opciones);
    },
    descargarPresupuestosGastosPorGrupoPorMeses() {
      const opciones = {
        params: {
          tipo: this.tiposPresupuestos.GASTO,
        },
      };

      return this.descargarExcel(ReportesExcelService.agrupadoPorMeses, this.presupuesto.id, opciones);
    },
  },
};
</script>

<style scoped>
.item-tab {
  max-height: calc(100vh - 19rem);
  min-height: calc(100vh - 19rem);
  overflow-y: auto;
}
</style>